import { ICreateAcoesPrevetivaCorretivaUseCase } from "../../../presentation/useCases/create/create_acao_preventiva_corretiva_servicos_use_case";
import { ICreateAcoesPreventivasUseCase } from "../../../presentation/useCases/create/create_acoes_preventivas_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// CreateAcoesPreventivasUseCase


export class CreateAcaoPreventivaCorretivaUseCase implements ICreateAcoesPrevetivaCorretivaUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async createAcaoPreventivaCorretiva(
  IdAcaoQualidade: number, Tipo: 'C' | 'P' | null, Numero: number | null,  Descricao: string | null, IdFuncionarioResponsavel: number | null,  DataPrevista: Date | null, DataRealizado: Date | null, AnaliseEvidencia: string | null, DataAnalise: Date | null, FoiEficaz: boolean | null, IdFuncionarioAnalise: number | null): Promise<void> {
    
    await this.repository.createAcaoPreventivaCorretiva(
       IdAcaoQualidade, Tipo, Numero, Descricao, IdFuncionarioResponsavel, DataPrevista, DataRealizado, AnaliseEvidencia, DataAnalise, FoiEficaz, IdFuncionarioAnalise
    );
  }
}
